const state = {
    csrf: document.head.querySelector('meta[name="csrf-token"]').content,
};

const getters = {
    csrf: (state) => {
        return state.csrf;
    },
};

const mutations = {};

const actions = {};


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
